export default __webpack_public_path__ + "static/media/figure-white.d9afa25c.jpg";